var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFloatingSidebar)?_c('b-icon',{staticClass:"sidebar-ctl",attrs:{"icon":"text-indent-right"},on:{"click":_vm.handleOnClickMenuIcon}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }